/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEntityEnum } from './APIEntityEnum';
import {
    APIEntityEnumFromJSON,
    APIEntityEnumFromJSONTyped,
    APIEntityEnumToJSON,
} from './APIEntityEnum';

/**
 * 
 * @export
 * @interface APIMarkReadRequestRequest
 */
export interface APIMarkReadRequestRequest {
    /**
     * 
     * @type {APIEntityEnum}
     * @memberof APIMarkReadRequestRequest
     */
    entity: APIEntityEnum;
    /**
     * 
     * @type {number}
     * @memberof APIMarkReadRequestRequest
     */
    id: number;
}



/**
 * Check if a given object implements the APIMarkReadRequestRequest interface.
 */
export function instanceOfAPIMarkReadRequestRequest(value: object): value is APIMarkReadRequestRequest {
    if (!('entity' in value) || value['entity'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIMarkReadRequestRequestFromJSON(json: any): APIMarkReadRequestRequest {
    return APIMarkReadRequestRequestFromJSONTyped(json, false);
}

export function APIMarkReadRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMarkReadRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entity': APIEntityEnumFromJSON(json['entity']),
        'id': json['id'],
    };
}

export function APIMarkReadRequestRequestToJSON(value?: APIMarkReadRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entity': APIEntityEnumToJSON(value['entity']),
        'id': value['id'],
    };
}

